module.exports = "/packs/images/svg/ireland/facilities/gym~320d26845c3735cbd08f5b7237242af4.svg";